import { jsonToHtml } from "../../utils/richtextUtil";

export const RichTextSummary = ({ richtext }: { richtext?: string }) => {
  if (!richtext) return null;
  let json = [];
  try {
    json = JSON.parse(richtext);
  } catch (e) {}
  const s = stringToDOM<HTMLDivElement>(jsonToHtml(json))?.innerText ?? "";
  return <>{s}</>;
};
function stringToDOM<T extends HTMLElement>(htmlString: string): T | null {
  try {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString.trim();
    return tempDiv.firstChild as T | null;
  } catch (e) {
    console.error(e);
  }
  return null;
}
